class CartUpsellCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cart-upsell__grid');
    if (!this.track) return;

    this.isPointerDown = false;
    this.didDrag = false;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClickCapture = this.onClickCapture.bind(this);

    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerUp);
    this.track.addEventListener('pointerleave', this.onPointerUp);
    this.track.addEventListener('click', this.onClickCapture, true);
    this.track.addEventListener('dragstart', this.preventNativeDrag);
  }

  preventNativeDrag(event) {
    event.preventDefault();
  }

  onPointerDown(event) {
    if (event.pointerType === 'touch') return;
    this.isPointerDown = true;
    this.didDrag = false;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
  }

  onPointerMove(event) {
    if (!this.isPointerDown) return;
    const distance = event.clientX - this.startX;
    if (Math.abs(distance) > 4) {
      this.didDrag = true;
      this.track.classList.add('is-dragging');
      if (this.track.setPointerCapture) {
        try {
          this.track.setPointerCapture(event.pointerId);
        } catch (error) {
          void error;
        }
      }
    }
    if (this.didDrag) {
      this.track.scrollLeft = this.startScrollLeft - distance;
    }
  }

  onPointerUp() {
    this.isPointerDown = false;
    this.track.classList.remove('is-dragging');
  }

  onClickCapture(event) {
    if (this.didDrag) {
      event.preventDefault();
      event.stopPropagation();
      this.didDrag = false;
    }
  }
}

if (!customElements.get('cart-upsell-carousel')) {
  customElements.define('cart-upsell-carousel', CartUpsellCarousel);
}
